import React from 'react';
import Store from './BreadCrumbContext';

export default function xcxxx(props) {
    return (
    <Store>
        {props.children}
    </Store>
    );
}